export default __webpack_public_path__ + "static/media/pod2.815a2507.jpg";